import { baseQueryWithLogout } from "@/lib/baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { SearchResult } from "./search.type";

export const SearchApi = createApi({
  reducerPath: "searchApi",
  tagTypes: ["search"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    search: build.query<SearchResult, string>({
      query: (query) => ({
        url: `search?q=${query}`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useSearchQuery,
} = SearchApi;
